import { createElement } from 'react';
import { Select, Space } from 'antd';
const UcmlSelectManBox = function UcmlSelectManBox({ ...otherProps }) {
    const _otherProps = otherProps || {};
    let lname = '';
    if (_otherProps.islabel)
        lname = _otherProps.labelName;
    return (createElement(Space, { align: "center" },
        lname,
        createElement(Select, { disabled: true, value: _otherProps.SelectMode, style: { width: 300 }, options: [
                { value: '1', label: '多选人员、部门、岗位、群组、相对岗位' },
                { value: '2', label: '多选人员、部门、岗位、群组' },
                { value: '3', label: '多选人员、部门、岗位' },
                { value: '4', label: '多选人员、群组' },
                { value: '5', label: '多选人员、部门' },
                { value: '6', label: '单选人员' },
                { value: '7', label: '多选人员、部门、群组' },
                { value: '8', label: '多选人员' },
                { value: '9', label: '多选部门' },
                { value: '10', label: '多选岗位' },
                { value: '11', label: '多选群组' },
                { value: '12', label: '多选人员、相对岗位' },
                { value: '13', label: '多选人员、部门、岗位、群组、相对岗位、工作流节点配置' },
                { value: '14', label: '工作流节点配置' },
                { value: '40', label: '群组多选人' },
                { value: '41', label: '群组单选人' }
            ], ..._otherProps })));
};
export default UcmlSelectManBox;
